import React, { useState, useEffect, useRef } from 'react';
import searchIconSolid from '../../images/icons/searchIconSolid.svg';
import searchDelete from '../../images/icons/searchDelete.svg';
import lodash from 'lodash';
import {
  getAvailableListsForReassign,
  assigneNewOwner
} from '../../common/constants/api';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import PopUp from '../../common/components/PopUp/PopUp';
import Modal from '../../common/components/Modal/modal';

const AssignOwner = props => {
  const [searchIcon, setSearchIcon] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const [popUpType, setpopUpType] = useState('loading');
  const [popUpText, setpopUpText] = useState('Loading...');

  const [loading, setLoading] = useState(true);
  const [assgineeeOptions, setAssigneeOptions] = useState([]);
  const [masterResponse, storeMasterResponse] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [selectedValue, setSelectedValue] = useState('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setpopUpText('Getting user list. Please wait...');
    setpopUpType('loading');
    setLoading(true);
    getAvailableListsForReassign(props.leadId)
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        setLoading(false);
        storeMasterResponse(res);
        setAssigneeOptions(res);
        setShowModal(true);
      })
      .catch(error => {
        setLoading(false);
        setTimeout(function() {
          props.setShowReassign(false);
        }, 2000);
      });
  }, []);

  const handleOnSelection = value => {
    setSearchValue(value.fullName);
    setSearchIcon(false);
    setAssigneeOptions([]);
    if (!value) return;
    setSelectedValue(value);
  };

  const handleSubmittion = () => {
    setShowModal(false);
    setSubmitting(true);
    setpopUpText(
      props?.submitText
        ? props.submitText
        : 'Changing owner for the lead. Please wait...'
    );
    setpopUpType('loading');
    setLoading(true);

    assigneNewOwner(props?.leadId, selectedValue?.userId)
      .then(res => {
        if (res.error) throw new Error(res);
        setLoading(false);
        props.setShowReassign(false);
        if (typeof props?.setOwnerName == 'function') {
          props?.setOwnerName(selectedValue?.fullName);
        }
        if (typeof props?.onSuccess == 'function') props.onSuccess();
      })
      .catch(error => {
        setLoading(false);
        setSubmitting(false);
        setTimeout(function() {
          props.setShowReassign(false);
        }, 2000);
      });
  };

  const updateList = e => {
    setSearchValue(e.target.value);
    let newList = [];
    masterResponse.map(each => {
      if (
        !each?.fullName?.toLowerCase().includes(e?.target?.value?.toLowerCase())
      )
        return;
      newList.push(each);
    });
    setAssigneeOptions(newList);
  };

  const handleReset = () => {
    setSearchValue('');
    setSearchIcon(true);
    setAssigneeOptions(masterResponse);
  };
  useEffect(() => {
    if (!showModal && !loading) {
      props.setShowReassign(false);
    }
  }, [showModal]);
  return (
    <React.Fragment>
      <Modal show={showModal} setShow={setShowModal}>
        <div className="w-full block  bg-white mx-auto">
          <p className="text-base text-grey-995 text-left font-roboto font-normal py-1 ">
            {props.name} - {props?.leadId}
          </p>
          <hr className="text-grey-999 my-2" />
          {props?.ownerName ? (
            <div className="w-full bg-grey-1004 block py-1 px-3 mt-4">
              <p className="font-roboto  text-black-500 py-4 text-base font-norml  text-left">
                {props.header ? props.header : 'Current Owner'}
              </p>
              <p className="font-roboto  text-green-600 pb-4 text-base font-norml  text-left">
                {props?.ownerName}
              </p>
            </div>
          ) : null}
          <p className="text-base text-black-500 text-left font-roboto font-normal pt-7">
            {props.actionHeader ? props.actionHeader : 'Assign New Owner'}
          </p>
          <div className="w-11/12 mx-auto flex shadow-2xl  px-4 mt-5   items-center rounded  border-blue-600 hover:border-2 border-2">
            {searchIcon ? (
              <div>
                <img
                  src={searchIconSolid}
                  alt="search rm "
                  className="w-4 mr-auto "
                />
              </div>
            ) : null}
            <input
              className="w-10/12 placeholder-grey-1001 ml-3 text-sm font-roboto font-normal h-10"
              placeholder="Search RM"
              onChange={updateList}
              disabled={!searchIcon}
              value={searchValue}
            />
            {!searchIcon ? (
              <div>
                <img
                  src={searchDelete}
                  className="w-4 ml-auto cursor-pointer "
                  alt="delete"
                  onClick={handleReset}
                />
              </div>
            ) : null}
          </div>
          <div
            className={`block w-11/12  mx-auto relative  shadow rounded  ${
              assgineeeOptions.length == 0 ? 'mb-14' : ' mb-10 overflow-auto'
            }`}
            style={{ maxHeight: '140px' }}
          >
            <div className="text-left font-roboto font-normal text-sm text-black-500 px-2  my-2">
              {assgineeeOptions.map(each => {
                return (
                  <div className="py-3 w-full">
                    <span
                      className="cursor-pointer"
                      onClick={() => handleOnSelection(each)}
                    >
                      {each.fullName}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="w-full flex ">
            <button
              className="w-24 px-3 py-3 bg-grey-1002 text-grey-1003 font-roboto font-normal rounded ml-auto  "
              onClick={() =>
                typeof props?.setShowReassign == 'function'
                  ? props.setShowReassign(false)
                  : null
              }
            >
              Cancel
            </button>
            <button
              type="button"
              className={
                searchIcon || submitting
                  ? 'w-24 px-3 py-3 bg-grey-1002 text-grey-1003 font-roboto font-normal rounded mx-3 bg-grey-1002 text-white font-bold py-2 px-4 rounded  cursor-not-allowed'
                  : 'w-24 px-3 py-3 bg-green-600 text-white font-roboto font-normal rounded mx-3 bg-grey-1002 text-white font-bold py-2 px-4 rounded'
              }
              disabled={searchIcon}
              onClick={handleSubmittion}
            >
              Assign
            </button>
          </div>
        </div>
      </Modal>

      <PopUp
        type={popUpType}
        text={popUpText}
        show={loading}
        setShow={setLoading}
      />
    </React.Fragment>
  );
};

export default withErrorHandler(AssignOwner);
